module.exports = __webpack_public_path__ + "static/popper-text-45fb69958c6fc80df98607583c280b4b.svg";